export const containerStyles = `
    flex p-4px gap-1 rounded-12px items-center border border-gray-200 bg-gray-100
`
export const buttonContainerStyles = `
    p-1 outline-none bg-base-white rounded-8px shadow hover:scale-105 active:scale-95 transition-all
`
